// helpers.ts — Pure utility functions for PWP254 (Packing List) form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Format number with 1 decimal */
export const fmt1 = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0.0';
  return v.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
};

/** Format number with 4 decimals (for rates) */
export const fmtRate = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0.0000';
  return v.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 });
};

/** BR-C02: Calculate single detail row YDS/MTS/GW/NW */
export const calcDetailRow = (
  row: Record<string, number>,
  mtsRate: number,
  nwRate: number,
  gwRate: number,
): { fp611_41: number; fp611_42: number; fp611_43: number; fp611_44: number } => {
  const yds = (row.fp611_21 || 0) + (row.fp611_22 || 0) + (row.fp611_23 || 0) + (row.fp611_24 || 0);
  const mts = Math.round(mtsRate * yds);
  const patchTotal = (row.fp611_51 || 0) + (row.fp611_52 || 0) + (row.fp611_53 || 0) + (row.fp611_54 || 0);
  const gw = nwRate * (yds + patchTotal);
  const nw = Math.floor(gw) + gwRate;
  return { fp611_41: yds, fp611_42: mts, fp611_43: gw, fp611_44: nw };
};

/** BR-C01: Recalculate master totals from all detail rows */
export const calcMasterTotals = (
  details: Record<string, number>[],
): { fp610_17: number; fp610_18: number; fp610_19: number; fp610_20: number } => {
  let totalYDS = 0, totalMTS = 0, totalGW = 0, totalNW = 0;
  for (const d of details) {
    totalYDS += d.fp611_41 || 0;
    totalMTS += d.fp611_42 || 0;
    totalGW += d.fp611_43 || 0;
    totalNW += d.fp611_44 || 0;
  }
  return {
    fp610_17: totalYDS,
    fp610_18: Math.round(totalMTS * 100) / 100,
    fp610_19: totalGW,
    fp610_20: totalNW,
  };
};
